/**
 * Shared shop-owner dashboard utilities (constants, nav, formatting).
 * Used by ShopOwnerDashboard and tab components.
 */

export const WEEKS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

/** Map English day name → i18n key for display (logic stays in English). */
export const DAY_TO_I18N = {
  Sunday: 'ownerSunday',
  Monday: 'ownerMonday',
  Tuesday: 'ownerTuesday',
  Wednesday: 'ownerWednesday',
  Thursday: 'ownerThursday',
  Friday: 'ownerFriday',
  Saturday: 'ownerSaturday',
};
export const HOURS = Array.from({ length: 16 }, (_, i) => `${(i + 8).toString().padStart(2, '0')}:00`);
export const TOWNS = [
  'Maadi', 'Masr El Gedida', 'Heliopolis', 'Nasr City', 'New Cairo',
  'October City', 'Zamalek', 'Mohandessin', 'Dokki', 'Giza',
];
export const serviceBoxes = [
  'Hair & Nail', 'Barber', 'Tattoo and Piercing',
  'Laser Clinics', 'Brows & lashes',
  'Makeup', 'Massage', 'Pet Services',
];

/** (t, icons) => nav items; icons = { profile, calendar, history, analytics, logout } */
export const makeNav = (t, icons = {}) => [
  { key: 'profile', title: t('ownerNavProfile'), icon: icons.profile },
  { key: 'calendar', title: t('ownerNavCalendar'), icon: icons.calendar },
  { key: 'history', title: t('ownerNavAppointments'), icon: icons.history },
  { key: 'analytics', title: t('ownerNavAnalytics'), icon: icons.analytics },
  { key: 'logout', title: t('ownerNavLogout'), icon: icons.logout },
];

export const norm = (s = '') => String(s).trim().toLowerCase();

/** iOS Safari: clean stray glyphs from displayed numeric strings */
export const cleanText = (t) => String(t ?? '').replace(/[|‖¦\-‑–—]/g, '');
